import { render, staticRenderFns } from "./tutorials-customization.vue?vue&type=template&id=1a8159bc&scoped=true"
import script from "./tutorials-customization.vue?vue&type=script&lang=js"
export * from "./tutorials-customization.vue?vue&type=script&lang=js"
import style0 from "./tutorials-customization.vue?vue&type=style&index=0&id=1a8159bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8159bc",
  null
  
)

export default component.exports